import React, { useState, useEffect } from 'react';
import { IoIosArrowDown, } from 'react-icons/io';
import tw from 'tailwind-styled-components';
import { useDispatch } from 'react-redux';
import { getUserType } from "../helpers";

const PayerDropdown = ({ options, name, onChange, disabled, value }) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [closeTimeout, setCloseTimeout] = useState(null);
    const [selectedOption, setSelectedOption] = useState(
        options?.find(option => option?.id === value?.id) || null
    );
    const handleMouseEnter = () => {
        if (closeTimeout) {
            clearTimeout(closeTimeout);
        }
        setIsOpen(true);
    };

    const handleMouseLeave = () => {
        const timeout = setTimeout(() => {
            setIsOpen(false);
        }, 250);

        setCloseTimeout(timeout);
    };

    const handleOptionSelect = (option) => {
        onChange(option);
        setSelectedOption(option);
        setIsOpen(false);
    };

    useEffect(() => {
        return () => {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }
        };
    }, [closeTimeout]);
    useEffect(() => {

        setSelectedOption(options?.find(option => option?.id === value?.id) || null);
    }, [value, options]);
    return (
        <DropdownContainer >
            <DropdownButton
                onClick={() => setIsOpen(!isOpen)}
                onMouseLeave={handleMouseLeave}
                disabled={disabled}
                type="button"
            >
                <span className='ml-1'>{selectedOption?.name || name}</span>
                <div>
                    <IoIosArrowDown />
                </div>
            </DropdownButton>

            {isOpen && (
                <DropdownMenu
                    onMouseEnter={handleMouseEnter}
                >
                    {options.map((option) => {

                        return (
                            <Card
                                key={option?.id}
                                onClick={() => handleOptionSelect(option)}
                            >
                                <Header>
                                    <Name>{option?.name}</Name>
                                </Header>

                                <Details>
                                    <Item title="Active Tenants">
                                        <Role>{getUserType(option.userType || 0)}</Role>
                                    </Item>

                                </Details>
                            </Card>
                        );
                    })}
                </DropdownMenu>
            )}
        </DropdownContainer>
    );
};
const DropdownButton = tw.button`
  flex items-center px-2 py-3  text-gray-800 text-sm justify-between w-full
  ${({ disabled }) => disabled && 'cursor-not-allowed opacity-50'}
`;
const DropdownContainer = tw.div`relative items-center h-12 border border-gray-300 rounded-sm custom-scrollbar rounded-md`;
const DropdownMenu = tw.div`absolute top-full left-0 bg-white border border-gray-200 rounded-b-lg shadow-lg z-10 transition-opacity duration-300 ease-in-out mt-3 overflow-y-scroll max-h-60 rounded-md`;
const Card = tw.div`p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 last:border-b-0 w-52`;
const Header = tw.div`flex justify-between items-start mb-1`
const Name = tw.div`text-gray-800 text-md`;
const Details = tw.div`flex items-center justify-between text-sm text-gray-600`
const Item = tw.div`flex items-center gap-1`
const Role = tw.div`text-sm text-primary-color`;

export default PayerDropdown;